import jwt, { JwtPayload } from "jsonwebtoken"

export const store = {
  get key(): string | null {
    console.log("load");
    const _key = window.sessionStorage.getItem("key");
    if (_key) {
      const result = jwt.decode(_key);
      if (result && (result as JwtPayload)?.exp) {
        const exp = (result as JwtPayload)?.exp as number;
        if (Date.now() > exp * 1000) {
          window.sessionStorage.removeItem("key");

          console.log("exceeded");
          return null;
        }
        return _key;
      }
    } else {
      console.log("unknown");
      window.sessionStorage.removeItem("key");
      return null;
    }
    return null;
  },
  set key(_key: string | null) {
    console.log("store");
    if (_key) {
      const result = jwt.decode(_key);
      if (result && (result as JwtPayload)?.exp) {
        const exp = (result as JwtPayload)?.exp as number;
        if (Date.now() > exp * 1000) {
          window.sessionStorage.removeItem("key");
          return;
        }
        window.sessionStorage.setItem("key", _key);
        return;
      }
    } else {
      window.sessionStorage.removeItem("key");
      return;
    }
    return;
  }

}
export default store;